import React from "react";

type Props = {
  title: string;
  value: string | JSX.Element;
  hideTitleOn: "sm" | "md" | "lg";
  titleClassName?: string;
  valueClassName?: string;
};

const InfoItemMobile = ({
  title,
  value,
  hideTitleOn,
  titleClassName,
  valueClassName,
}: Props) => {
  return (
    <div className={`d-flex d-${hideTitleOn}-block justify-content-between`}>
      <div className={`d-${hideTitleOn}-none text-muted pr-2 ${titleClassName ?? ""}`}>
        {title}
      </div>
      <div className={valueClassName}>
        {value}
      </div>
    </div>
  );
};

export default InfoItemMobile;
